import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { ReactLenis } from "lenis/react";
import i18n from "./i18n";
import ScrollToTop from "./components/base/ScrollToTop";

const lenisOptions = {
  duration: 1.2,
  easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: true,
  wheelMultiplier: 1,
  touchMultiplier: 1.5,
  anchors: true,
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ReactLenis root options={lenisOptions}>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </ReactLenis>
    </I18nextProvider>
  );
}

export default App;
